import { createContext, type ReactNode, useContext, useState } from 'react'

interface FilesContextProps {
  hasSearched: boolean
  setHasSearched: (value: boolean) => void
  isLoadingUploads: boolean
  setIsLoadingUploads: (value: boolean) => void
}

export const FilesContext = createContext<FilesContextProps>(
  {} as FilesContextProps,
)

export const FilesContextProvider = ({ children }: { children: ReactNode }) => {
  const [hasSearched, setHasSearched] = useState(false)
  const [isLoadingUploads, setIsLoadingUploads] = useState(false)

  return (
    <FilesContext.Provider
      value={{
        hasSearched,
        setHasSearched,
        isLoadingUploads,
        setIsLoadingUploads,
      }}
    >
      {children}
    </FilesContext.Provider>
  )
}

export const useFilesContext = () => {
  const context = useContext(FilesContext)

  if (!context) {
    throw new Error('useFilesContext must be whitin FilesContextProvider')
  }

  return context
}
